import { useEffect, useRef } from 'react';

import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import type { ErrorPair } from '@app/types';

function fingerprintError(err: unknown): string {
  if (typeof err === 'string') return err;

  if (err && typeof err === 'object') {
    try {
      return JSON.stringify(err);
    } catch {
      return String(err);
    }
  }

  return String(err);
}

export const useErrorHandler = (errors: ErrorPair[]) => {
  const { showNotification } = useNotification();

  const prevKeysRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    const currentKeys = new Set<string>();

    for (const { flag, error } of errors) {
      if (!flag || !error) continue;

      const key = fingerprintError(error);
      currentKeys.add(key);

      if (!prevKeysRef.current.has(key)) {
        showNotification(error);
      }
    }

    prevKeysRef.current = currentKeys;
  }, [errors, showNotification]);
};
